import React from "react";
import { Icons } from "../../exports/icons";

const HealthIndicatorCell: React.FC = () => (
  <td style={{ padding: "16px 8px 16px 20px", width: "48px" }}>
    <img
      src={Icons.circleGreenCheckmark}
      alt="Healthy"
      width={20}
      height={20}
      style={{ verticalAlign: "middle", display: "block" }}
    />
  </td>
);

export default HealthIndicatorCell;
